import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';


class DEAItemsRule extends Component {
  constructor(props) {
    super(props);
    _.bindAll(this, 'onSubmit', 'onReset');
    const { initialValues } = props;
    this.initialState = {
      count: initialValues.count || 5,
      schedule: initialValues.schedule || 3,
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      kind: 'dea_items',
      regions: _.filter(this.state.regions),
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { count, schedule, regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineInputNumber
          label='Minimum Quantity'
          description='Amount of DEA items in an order'
          value={count}
          onChange={value => this.setState({ count: value })}
        />
        <InlineInputNumber
          label='DEA Schedule'
          description='Schedule 1 is highest risk for abuse'
          value={schedule}
          onChange={value => this.setState({ schedule: value })}
        />
      </RuleForm>
    );
  }
}

DEAItemsRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

DEAItemsRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default DEAItemsRule;
